import styled from 'styled-components';

import { SmallParagraph, style } from '@genially/design-system';

export const Header = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: size.units(1),
  textAlign: 'center',
  padding: `${size.units(2)} 0`,
}));

export const SubsectionHeader = styled.div(({ theme: { size } }) => ({
  paddingTop: size.units(2),

  '&:first-child': {
    paddingTop: 0,
  },
}));

export const Content = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(1),
  padding: `${size.units(2)} 0`,

  [SubsectionHeader]: {
    marginTop: size.units(1),
  },

  [`${SubsectionHeader}:first-child`]: {
    marginTop: 0,
  },
}));

export const SectionHeader = styled.div({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
});

export const SectionHint = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.secondary.default(),
}));

interface TogglesProps {
  $columns: number;
}

export const Toggles = styled.div<TogglesProps>(({ theme: { size }, $columns }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${$columns}, 1fr)`,
  gap: size.units(2),

  // No width left to split below sm: one toggle per row.
  ...style.mixins.responsive.sm.downward({
    gridTemplateColumns: '1fr',
  }),
}));

export const FooterContent = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: size.units(2),
  width: '100%',
  paddingTop: size.units(3),
}));
